export default __webpack_public_path__ + "static/header-background-image-37752d8d968755d04d26dee71bd0ad41.svg";